var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { ifProp, switchProp } from 'styled-tools';
import { fontBody } from 'Styles/fonts';
import { convertColorToThemeHexCode } from 'Styles/colors.util';
import BaseIcon from '../Icons/Icon';
export var Icon = styled(BaseIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var ButtonTag = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-flex;\n  padding: 6px 12px;\n  height: 34px;\n  align-items: center;\n  color: ", ";\n  background: ", ";\n  cursor: ", ";\n  text-transform: capitalize;\n  border: none;\n  white-space: pre;\n  ", ";\n\n  ", " {\n    margin-left: 8px;\n  }\n"], ["\n  display: inline-flex;\n  padding: 6px 12px;\n  height: 34px;\n  align-items: center;\n  color: ", ";\n  background: ", ";\n  cursor: ", ";\n  text-transform: capitalize;\n  border: none;\n  white-space: pre;\n  ", ";\n\n  ", " {\n    margin-left: 8px;\n  }\n"])), switchProp('variant', {
    default: convertColorToThemeHexCode('grey80'),
    dark: convertColorToThemeHexCode('white'),
    light: convertColorToThemeHexCode('grey80'),
    error: convertColorToThemeHexCode('white')
}), switchProp('variant', {
    default: convertColorToThemeHexCode('offwhite'),
    dark: convertColorToThemeHexCode('black'),
    light: convertColorToThemeHexCode('offwhite'),
    error: convertColorToThemeHexCode('red')
}), ifProp('onClick', 'pointer', 'default'), fontBody(14), Icon);
var templateObject_1, templateObject_2;
